import { gql } from 'apollo-boost'

const USERS = gql`
  query users {
    users {
      id
      name
      email
    }
  }
`

export default USERS
